import React, { useEffect, useState } from "react";
import styles from './TextAreaField.module.scss';
import PropTypes from "prop-types";

const TextAreaField = ({
  label,
  value,
  placeholder,
  onChange,
  onBlur,
  disabled = false,
  error,
  limit,
}) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    setCount(value.length);
  }, [value]);

  return (
    <div className={styles.textAreaField}>
      {label && (
        <label className={styles.label}>{label}</label>
      )}
      <textarea
        className={`${styles.teaxtArea} ${error ? styles.errorInput : ''}`}
        rows="3"
        value={value || ''}
        placeholder={placeholder}
        onChange={({ target: { value } })=> {
          onChange(limit ? value.slice(0, limit) : value);
        }}
        onBlur={onBlur}
        disabled={disabled}
      ></textarea>
      <div className={styles.footer}>
        {error && <span className={styles.error}>{error}</span>}
        <span className={styles.spacer}></span>
        {limit && <span className={styles.limit}>{count}/{limit} characters</span>}
      </div>
    </div>
  );
};

TextAreaField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  limit: PropTypes.number
}

export default TextAreaField;